import { render, staticRenderFns } from "./cdeclaredetail.vue?vue&type=template&id=12bd1ac0&scoped=true"
import script from "./cdeclaredetail.vue?vue&type=script&lang=js"
export * from "./cdeclaredetail.vue?vue&type=script&lang=js"
import style0 from "./cdeclaredetail.vue?vue&type=style&index=0&id=12bd1ac0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bd1ac0",
  null
  
)

export default component.exports